import { render, staticRenderFns } from "./promotions.vue?vue&type=template&id=40ca1f0c"
import script from "./promotions.vue?vue&type=script&lang=js"
export * from "./promotions.vue?vue&type=script&lang=js"
import style0 from "./promotions.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/promotions/promotions.vue
// module id = TYLZ
// module chunks = 0